import { useEffect, useState, useCallback } from 'react';

export function useOfflineQueue() {
  const [queueDrained, setQueueDrained] = useState(false);
  const [drainedCount, setDrainedCount] = useState(0);

  useEffect(() => {
    const handler = (event) => {
      setQueueDrained(true);
      setDrainedCount(event.detail?.count || 0);
      // Auto-dismiss after 5 seconds
      setTimeout(() => setQueueDrained(false), 5000);
    };
    window.addEventListener('offline-queue-drained', handler);
    return () => window.removeEventListener('offline-queue-drained', handler);
  }, []);

  const dismiss = useCallback(() => setQueueDrained(false), []);

  return { queueDrained, drainedCount, dismiss };
}
